import { Badge, Card, Col, List, Row, Typography } from "antd";
import type { FC } from "react";

import { Palette } from "../../../../core/styles/palette";
import type { JobExecutionDto } from "../types/Dashboard";
import { formatRelativeTime } from "../utils/formatters";

const { Text } = Typography;

interface RecentJobExecutionsCardProps {
    jobExecutions: JobExecutionDto[];
}

/**
 * RecentJobExecutionsCard - Displays recent job executions with freshness indicators
 */
export const RecentJobExecutionsCard: FC<RecentJobExecutionsCardProps> = ({ jobExecutions }) => {
    const getJobFreshnessColor = (lastRun: string): string => {
        const now = new Date();
        const lastRunDate = new Date(lastRun);
        const hoursDiff = (now.getTime() - lastRunDate.getTime()) / (1000 * 60 * 60);

        if (hoursDiff < 1) return Palette.HeroGreen;
        if (hoursDiff < 6) return "#faad14"; // yellow
        if (hoursDiff < 24) return Palette.Warning;
        return Palette.AeviRed;
    };

    return (
        <Card title="Recent Job Executions" style={{ backgroundColor: "#FFFFFF", height: "100%" }}>
            <List
                size="small"
                dataSource={jobExecutions}
                renderItem={(job: JobExecutionDto) => {
                    const color = getJobFreshnessColor(job.lastRun);
                    return (
                        <List.Item>
                            <Row justify="space-between" style={{ width: "100%" }}>
                                <Col>
                                    <Text strong>{job.jobName}</Text>
                                </Col>
                                <Col>
                                    <Badge color={color} text={formatRelativeTime(job.lastRun)} />
                                </Col>
                            </Row>
                        </List.Item>
                    );
                }}
            />
        </Card>
    );
};
